import {
    GET_USERS,
    USER_ERROR,
    GET_USER,
    UPDATE_USER
} from "../../actions/types";

const initalizeState = {
    users: [],
    loading: true,
    error: {}
};

export default function(state = initalizeState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_USERS:
            return {
                ...state,
                users: payload.users,
                loading: false
            };
        case UPDATE_USER:
        case GET_USER:
            return {
                ...state,
                loading: false
            };
        case USER_ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        default:
            return state;
    }
}
